/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/AISessions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   AI SEssions redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Thursday, November 16, 2023 - 1:55 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/11/16  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sessionid: 0,
  companyid: 0,
  userid: 0,
  page: "",
  error: null,
  defaultToolPanel: "filter",
  sessionorder: "NAME ASC",
  search: "",
  columnStateSession: [],
};

const intFields = ["sessionid", "companyid", "userid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "AISessions",
  initialState,
  reducers: {
    updateSessionID: (state, action) => updateFieldReducer(state, action, "sessionid"),
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateUserID: (state, action) => updateFieldReducer(state, action, "userid"),
    updatePage: (state, action) => updateFieldReducer(state, action, "page"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnStateSession: (state, action) => updateFieldReducer(state, action, "columnStateSession"),
  },
});

export const {
  updateSessionID,
  updateCompanyID,
  updateUserID,
  updatePage,
  updateDefaultToolPanel,
  updateColumnStateSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
